<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.8 4.91a1 1 0 00-.8-.41H10.45L10 2.73A1 1 0 009 2H7a1 1 0 000 2h1.24l1.25 4.5h-3L6 6.73A1 1 0 005 6H3a1 1 0 000 2h1.24l2.3 8.27a1 1 0 001 .73H15a1 1 0 001-.71L17 13h2a1 1 0 001-.71l2-6.5a1 1 0 00-.2-.88zM14.26 15h-6L7 10.5h8.64l-.32 1a.93.93 0 00-.12.41zm4-4h-.68L18 9.79a1 1 0 00-.16-.88A1 1 0 0017 8.5h-5.43l-.57-2h8.64zM8.5 18.5a1.75 1.75 0 101.75 1.75A1.75 1.75 0 008.5 18.5zM13.5 18.5a1.75 1.75 0 101.75 1.75 1.75 1.75 0 00-1.75-1.75z"/></svg>